// Desktop presentation helpers. Never mutate source rows or recalculate existing metrics.
export function singleIdentityLabel(originalCount: number, visibleRows: Record<string, unknown>[]) {
  return originalCount === 1 && visibleRows.length === 1 ? String(visibleRows[0].label ?? "") : undefined;
}

export function weekdayLyUptTotals(rows: { previous_year_units: number; previous_year_receipts?: number | null }[], currentUpt: number) {
  const complete = rows.length > 0 && rows.every(row => row.previous_year_receipts != null);
  const receipts = complete ? rows.reduce((sum, row) => sum + row.previous_year_receipts!, 0) : 0;
  const lyUpt = receipts > 0 ? rows.reduce((sum, row) => sum + row.previous_year_units, 0) / receipts : null;
  return { lyUpt, uptChange: lyUpt != null && lyUpt !== 0 ? (currentUpt - lyUpt) / Math.abs(lyUpt) * 100 : null };
}

export function repeatedSubtotalScope(row?: Record<string, unknown>, key?: string) {
  return key === "scope" && row?.__kind === "subtotal" && row.scope === row.identity;
}
